module.exports = __webpack_public_path__ + "static/media/logo.2ac40bbb.svg";


/*****************
 ** WEBPACK FOOTER
 ** ./img/svg/logo.svg
 ** module id = 295
 ** module chunks = 0
 **/